import { Alert } from "@amzn/awsui-components-react-v3";
import React, { useContext, useEffect, useState } from "react";

import { agentChatLanguageSet } from "../../state/actions";
import { useDispatch } from "../../state/hooks";
import { AppStateContext } from "../../state/provider";
import { Translation } from ".";

export enum InitializationStatus {
  NotInitialized = "NotInitialized",
  Initializing = "Initializing",
  Initialized = "Initialized",
  InitializationFailed = "InitializationFailed",
}

export const TranslationControl: React.FC<unknown> = () => {
  const dispatch = useDispatch();
  const appState = useContext(AppStateContext);
  const [initializationStatus, setInitializationStatus] = useState(
    InitializationStatus.NotInitialized
  );
  const [showAlert, setShowAlert] = useState(!!appState.agentChatLanguage);

  useEffect(() => {
    if (appState.ccpInitialized) {
      setInitializationStatus(InitializationStatus.Initializing);
      connect.agent((agent) => {
        const initialized = Translation.instance.initTranslation(agent);
        setInitializationStatus(
          initialized
            ? InitializationStatus.Initialized
            : InitializationStatus.InitializationFailed
        );

        // Set agent chat language for all agents
        dispatch(agentChatLanguageSet(Translation.DEFAULT_AGENT_CHAT_LANGUAGE));
      });
    }
  }, [dispatch, appState.ccpInitialized]);

  useEffect(() => {
    setShowAlert(!!appState.agentChatLanguage);
  }, [appState.agentChatLanguage, initializationStatus, setShowAlert]);

  const onDismiss = (): void => setShowAlert(false);

  let alert = <></>;
  switch (initializationStatus) {
    case InitializationStatus.NotInitialized:
      alert = (
        <Alert
          type="warning"
          header="Translation is not initialized."
          dismissible={true}
          onDismiss={onDismiss}
        />
      );
      break;
    case InitializationStatus.Initializing:
      alert = (
        <Alert
          type="info"
          header="Translation is being initialized."
          dismissible={true}
          onDismiss={onDismiss}
        />
      );
      break;
    case InitializationStatus.Initialized:
      break;
    default:
      alert = (
        <Alert
          type="error"
          header="Failed to initialize translation."
          dismissible={true}
          onDismiss={onDismiss}
        />
      );
      break;
  }

  return <div className="awsui-visual-refresh">{showAlert && alert}</div>;
};
